import { TumbleDryerAlertIcon } from './TumbleDryerAlertIcon';

/**
 * author: Michael Irigoyen
 * id D21E17B9-0D84-4C21-977C-D1056E934449
 * name tumble-dryer-alert
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tumble-dryer-alert.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const LaundryRoomAlertIcon = TumbleDryerAlertIcon;
export default LaundryRoomAlertIcon